











































import Vue from "vue";
import Component from "vue-class-component";
import { TripEntity } from "../api/types";
import { Prop } from "vue-property-decorator";
import MatchList from "@/components/MatchList.vue";
import TripImage from "@/components/TripImage.vue";
import firebase from "firebase";
import TripsModule from "@/store/modules/trips";
import { getModule } from 'vuex-module-decorators';

const trips = getModule(TripsModule);

@Component({
  components: {
    MatchList,
    TripImage
  }
})
export default class TripPreview extends Vue {
  @Prop()
  readonly trip!: TripEntity;

  showTrip(trip: any) {
    this.$router.push("/trip/" + trip.id);
  }

  deleteTrip() {
    this.$ionic.alertController
      .create({
        header: "Delete trip?",
        subHeader: this.trip.destination,
        message: "Are you sure you want to delete this trip?",
        buttons: [
          "Cancel",
          {
            text: "OK",
            role: "ok",
            handler: data => {
              trips.deleteTrip(this.trip);
              //this.$store.dispatch('deleteStop', stop);
            }
          }
        ]
      })
      .then(a => a.present());
  }
}
